@for (item of items; track $index; let i = $index) { @if (i !== 0) {
<div class="step-divider">
  <span class="step-divider-dash"></span>
  <span class="step-divider-dash"></span>
</div>
}
<div
  class="step-item"
  [ngClass]="item.status"
  [ngStyle]="{ 'justify-content': onlyIcon ? 'center' : 'normal' }"
>
  @if(item.icon){
  <span nz-icon [nzType]="item.icon" [ngStyle]="{ 'font-size': '20px' }"></span>
  }
  <span *ngIf="!onlyIcon">{{ item.title }}</span>
</div>
}
